import { defineComponent, onMounted, onBeforeUnmount, openBlock, createElementBlock, normalizeStyle, unref, createElementVNode, renderSlot } from 'vue';
import { UiCarouselSeamlessPropsOption } from './index.mjs';
import { useComposable } from './src/composable.mjs';

const _hoisted_1 = { class: "ui-carousel-seamless-content ui-carousel-seamless-copy-content" };
var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: UiCarouselSeamlessPropsOption,
  setup(__props) {
    const define = __props;
    const { refs, methods, computeds } = useComposable(define);
    const { main, content, container } = refs;
    const { mouseenter, mouseleave } = methods;
    const { style } = computeds;
    onMounted(() => mouseleave());
    onBeforeUnmount(() => {
      refs.frame.value && window.cancelAnimationFrame(refs.frame.value);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(
        "div",
        {
          class: "ui-carousel-seamless",
          style: normalizeStyle(unref(style)),
          ref_key: "main",
          ref: main,
          onMouseenter: _cache[0] || (_cache[0] = //@ts-ignore
          (...args) => unref(mouseenter) && unref(mouseenter)(...args)),
          onMouseleave: _cache[1] || (_cache[1] = //@ts-ignore
          (...args) => unref(mouseleave) && unref(mouseleave)(...args))
        },
        [
          createElementVNode(
            "div",
            {
              class: "ui-carousel-seamless-container",
              ref_key: "container",
              ref: container
            },
            [
              createElementVNode(
                "div",
                {
                  class: "ui-carousel-seamless-content",
                  ref_key: "content",
                  ref: content
                },
                [
                  renderSlot(_ctx.$slots, "default")
                ],
                512
                /* NEED_PATCH */
              ),
              createElementVNode("div", _hoisted_1, [
                renderSlot(_ctx.$slots, "default")
              ])
            ],
            512
            /* NEED_PATCH */
          )
        ],
        36
        /* STYLE, NEED_HYDRATION */
      );
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=index.vue2.mjs.map
